import apps from './kioskApps'

export const normalizeKioskAppId = (appId) => {
  if (typeof appId !== 'string') return undefined

  const normalizedAppId = appId.trim().toLowerCase()
  return Object.hasOwn(apps, normalizedAppId) ? normalizedAppId : undefined
}

export default function resolveKioskApp({ urlApp, cachedApp, routerApp, defaultApp = 'aam' } = {}) {
  const app =
    normalizeKioskAppId(urlApp) ??
    normalizeKioskAppId(routerApp) ??
    normalizeKioskAppId(cachedApp) ??
    normalizeKioskAppId(defaultApp)

  return {
    app,
    appSettings: app ? apps[app] : undefined,
  }
}
